const messages = {
  en: {
    translations: {
      signup: {
        title: "Sign up",
        toasts: {
          success: "User created successfully! Please login!",
          fail: "Error creating user. Check the reported data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
        },
      },
      auth: {
        toasts: {
          success: "Login successfully!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Chats today: ",
          },
        },
        messages: {
          inAttendance: {
            title: "In Service"
          },
          waiting: {
            title: "Waiting"
          },
          closed: {
            title: "Closed"
          }
        },
      },
      connections: {
        title: "Connections",
        usage: {
          active: "Active",
          inactive: "Inactive",
        },
        toasts: {
          deleted: "WhatsApp connection deleted sucessfully!",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? It cannot be reverted.",
          disconnectTitle: "Disconnect",
          disconnectMessage: "Are you sure? You'll need to read QR Code again.",
          activateTitle: "Activate connection",
          activateMessage:
            "If your plan has already reached its active connection limit, another connection will be unlinked to free space.",
        },
        buttons: {
          add: "Add WhatsApp",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          connecting: "Connectiing",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your cell phone is connected to the internet and try again, or request a new QR Code",
          },
          qrcode: {
            title: "Waiting for QR Code read",
            content:
              "Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
          },
          connected: {
            title: "Connection established",
          },
          timeout: {
            title: "Connection with cell phone has been lost",
            content:
              "Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
          },
        },
        table: {
          platform: "Platform",
          name: "Name",
          connection: "Connection",
          status: "Status",
          usage: "Usage",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
        },
      },
      connectionModal: {
        title: {
          add: "Add WhatsApp",
          edit: "Edit WhatsApp",
        },
        form: {
          name: "Name",
          default: "Default",
          timeZone: "Time zone",
          serverTimeZone: "Use server time zone",
          queueRedirectEnabled: "Area redirection",
          farewellMessage: "Farewell Message",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "WhatsApp saved successfully.",
      },
      qrCode: {
        message: "Read QrCode to start the session",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact deleted sucessfully!",
        },
        searchPlaceholder: "Search ...",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related chats will be lost.",
          importMessage: "Do you want to import all contacts from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
        },
        table: {
          name: "Name",
          connection: "Connection",
          email: "Email",
          actions: "Actions",
        },
      },
      contactModal: {
        title: {
          add: "Add contact",
          edit: "Edit contact",
        },
        form: {
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          number: "Whatsapp number",
          email: "Email",
          extraName: "Field name",
          extraValue: "Value",
        },
        buttons: {
          addExtraInfo: "Add information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
      },
      quickAnswersModal: {
        title: {
          add: "Add Quick Reply",
          edit: "Edit Quick Answer",
        },
        form: {
          shortcut: "Shortcut",
          category: "Category",
          message: "Quick Reply",
          actionType: "Action",
          sequence: "Sequence",
        },
        actionTypes: {
          message: "Message",
          sequence: "Sequence",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Quick Reply saved successfully.",
      },
      chatbotModal: {
        title: { add: "Add sequence", edit: "Edit sequence" },
        sections: { schedule: "Schedule condition", chatbot: "Chatbot", quickReply: "Quick reply", execution: "Pause / Executions", transfer: "Transfer", labels: "Labels", ai: "AI", blocks: "Messages" },
        form: {
          name: "Name", category: "Category", parent: "Parent sequence", noParent: "No parent",
          matchType: "Match type", requireAllTriggers: "Require all triggers", trigger: "Triggers", triggerHelp: "Use one line break per trigger.", conditionalTriggerHelp: "Use one line per condition and commas for variations.",
          active: "Active", quickReplyEnabled: "Enable quick reply", quickReplyMatchType: "Match type", quickReplyTrigger: "Quick reply triggers", scheduleEnabled: "Restrict execution by schedule",
          startTime: "Start time", endTime: "End time",
          outOfHoursSequence: "Out-of-hours sequence", noOutOfHoursSequence: "Do not run another sequence",
          executionMode: "Execution mode",
          executionLimit: "Quantity", executionInterval: "Time", executionIntervalUnit: "Unit",
          transferType: "Transfer", transferQueue: "Area", transferUser: "User", noTransferAutoAssignQueues: "No area", noTransferAutoAssignUsers: "No user", transferAutoAssignRequired: "Select at least one area or user to enable distribution.", addLabels: "Add labels", removeLabels: "Remove labels", aiAction: "AI action", chatbotAction: "Chatbot action", aiInitialMessage: "Simulated customer initial message", aiPrompt: "Custom prompt",
          message: "Message", delay: "Wait for", noFile: "No file", inactivityMessage: "Inactivity message", inactivityValue: "Time", inactivityUnit: "Interval", inactivitySequence: "Sequence to run", noInactivitySequence: "Do not run a sequence",
        },
        matchTypes: { exact: "Exact", contains: "Contains", conditional: "Conditional", anything: "Anything", newChat: "New chat" },
        executionModes: { unlimited: "Unlimited", executionCount: "By execution count", timeWindow: "By elapsed time" },
        transferTypes: { none: "Do not transfer", queue: "To area", user: "To user", both: "To area and user", auto: "Auto-assignment", resolve: "Resolve" },
        aiActions: { none: "Do not change AI", activate: "Activate AI", activateReset: "Activate and reset AI", deactivate: "Turn off AI", deactivateReset: "Turn off AI and reset" },
        chatbotActions: { none: "Do not change", activate: "Activate", activateReset: "Activate and reset", deactivate: "Turn off", deactivateReset: "Turn off and reset" },
        units: { seconds: "Seconds", minutes: "Minutes", hours: "Hours", days: "Days", months: "Months" },
        buttons: { okAdd: "Add", okEdit: "Save", cancel: "Cancel", file: "Select file", removeFile: "Remove", addBlock: "Add message", addInactivityBlock: "Add inactivity message" },
        success: "Sequence saved successfully.",
      },
      queueModal: {
        title: {
          add: "Add area",
          edit: "Edit area",
        },
        form: {
          name: "Name",
          color: "Color",
          greetingMessage: "Greeting Message",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Department saved successfully.",
      },
      userModal: {
        title: {
          add: "Add user",
          edit: "Edit user",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          profile: "Profile",
          connection: "Default Connection",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "User saved successfully.",
      },
      chat: {
        noTicketMessage: "Select a chat to start chatting.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Areas",
      },
      tickets: {
        toasts: {
          deleted: "The chat you were on has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search chats and messages.",
        },
        buttons: {
          showAll: "All",
        },
        chatFilters: {
          all: "All",
          groups: "Groups",
          contacts: "People",
          unread: "Unread",
        },
      },
      transferTicketModal: {
        title: "Transfer chat",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to area",
        fieldConnectionLabel: "Transfer to connection",
        fieldQueuePlaceholder: "Please select an area",
        fieldConnectionPlaceholder: "Please select a connection",
        noOptions: "No user found with this name",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      ticketsList: {
        pendingHeader: "Area",
        assignedHeader: "Working on",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage: "No chats found with this status or search term.",
        connectionTitle: "Connection that is currently being used.",
        agentTitle: "Agent currently handling this chat.",
        buttons: {
          accept: "Accept",
        },
      },
      newTicketModal: {
        title: "Create chat",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          tickets: "Chats",
          contacts: "Contacts",
          quickAnswers: "Quick Answers",
          reminders: "Reminders",
          agenda: "Agenda",
          orders: "Orders",
          campaigns: "Campaigns",
          internalChat: "Internal Chat",
          funnels: "Funnels",
          chatbot: "Chatbot",
          ai: "AI",
          queues: "Areas",
          administration: "Administration",
          users: "Users",
          settings: "Settings",
          superAdmin: "Super Admin",
          accounts: "Accounts",
          labels: "Labels",
        },
        appBar: {
          user: {
            profile: "Profile",
            logout: "Logout",
          },
        },
      },
      notifications: {
        noTickets: "No notifications.",
      },
      queues: {
        title: "Areas",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting message",
          actions: "Actions",
        },
        buttons: {
          add: "Add area",
        },
        toasts: {
          deleted: "Department deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? It cannot be reverted! Chats in this area will still exist, but will not have any areas assigned.",
        },
      },
      queueSelect: {
        inputLabel: "Areas",
      },
      ticketLabels: {
        inputLabel: "Labels",
        placeholder: "Add labels",
        filterLabel: "Labels",
      },
      labels: {
        title: "Labels",
        table: { name: "Name", color: "Color", actions: "Actions" },
        buttons: { add: "Add label" },
        toasts: { deleted: "Label deleted successfully" },
        confirmationModal: {
          deleteTitle: "Delete label",
          deleteMessage: "This action cannot be undone.",
        },
      },
      labelModal: {
        title: { add: "Add label", edit: "Edit label" },
        form: { name: "Name", color: "Color" },
        buttons: { okAdd: "Add", okEdit: "Save", cancel: "Cancel" },
        success: "Label saved successfully.",
      },
      quickAnswers: {
        title: "Quick Answers",
        table: {
          shortcut: "Shortcut",
          category: "Category",
          message: "Quick Reply",
          actions: "Actions",
        },
        buttons: {
          add: "Add Quick Reply",
        },
        toasts: {
          deleted: "Quick Reply deleted successfully.",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Quick Reply: ",
          deleteMessage: "This action cannot be undone.",
        },
      },
      agendaPage: {
        title: "Agenda",
      },
      remindersPage: {
        title: "Reminders",
        form: {
          contact: "Contact",
        },
        table: {
          contact: "Contact",
          connection: "Connection",
          date: "Date and time",
          status: "Status",
          message: "Message",
          actions: "Actions",
        },
        buttons: {
          add: "Add reminder",
        },
        validation: {
          contact: "Select a contact.",
        },
        empty: "No scheduled reminders.",
      },
      internalChat: {
        title: "Internal Chat",
        empty: "Create or select an internal chat to start.",
        inputPlaceholder: "Write a message",
        buttons: {
          new: "New",
          cancel: "Cancel",
          create: "Create",
          save: "Save",
        },
        create: {
          title: "Create internal chat",
          name: "Internal Chat Name",
          users: "Users",
        },
        edit: {
          title: "Edit internal chat",
        },
      },
      chatbot: {
        title: "Chatbot",
        table: { name: "Sequence", category: "Category", parent: "Parent", matchType: "Match", blocks: "Messages", status: "Status", actions: "Actions" },
        status: { active: "Active", inactive: "Inactive" },
        buttons: { add: "Add sequence" },
        toasts: { deleted: "Sequence deleted successfully." },
        searchPlaceholder: "Search...",
        confirmationModal: { deleteTitle: "Delete this sequence?", deleteMessage: "This action cannot be undone." },
      },
      ai: {
        title: "AI",
        form: { active: "Enable AI", apiKey: "OpenAI API Key", model: "AI model", skipMarkAsRead: "Do not mark as read when replying", waitModeEnabled: "Wait mode", waitModeSeconds: "Wait time in seconds", applyConversationContext: "Apply conversation context", conversationContextMessages: "Context messages", prompt: "Prompt" },
        buttons: { save: "Save" },
        toasts: { saved: "AI settings saved successfully." },
      },
      users: {
        title: "Users",
        table: {
          name: "Name",
          email: "Email",
          profile: "Profile",
          connection: "Default Connection",
          actions: "Actions",
        },
        buttons: {
          add: "Add user",
        },
        toasts: {
          deleted: "User deleted sucessfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Users' open chats will be moved to area.",
        },
      },
      superAdmin: {
        title: "SaaS Accounts",
        sections: {
          users: "Users",
          connections: "Connections",
        },
        table: {
          name: "Name",
          email: "Email",
          profile: "Profile",
          status: "Status",
          connection: "Connection",
          default: "Default",
          actions: "Actions",
        },
        form: {
          expiresAt: "Expiration date",
          maxUsers: "User limit",
          maxConnections: "Connection limit",
        },
        buttons: {
          refresh: "Refresh",
          enter: "Enter",
          saveExpiration: "Save expiration",
          clearExpiration: "No expiration",
          saveSettings: "Save limits",
          clearLimits: "No limits",
          delete: "Delete",
          reset: "Clean account",
        },
        values: {
          yes: "Yes",
          no: "No",
          active: "Active",
          expired: "Expired",
        },
        toasts: {
          expirationSaved: "Expiration date saved.",
          settingsSaved: "Account settings saved.",
          deleted: "Account deleted successfully.",
          reset: "Account cleaned successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete account",
          deleteMessage:
            "This will delete the SaaS account and all its users, connections, contacts, chats, and settings. This action cannot be undone.",
          resetTitle: "Clean account",
          resetMessage:
            "This will delete secondary users, connections, contacts, chats, automations, and settings from this account. Only the main admin user will be kept. This action cannot be undone.",
        },
        empty: {
          accounts: "No accounts found.",
          connections: "This account has no connections.",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        settings: {
          userCreation: {
            name: "User creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          dashboardWebChatScript: {
            name: "Dashboard WebChat script",
            helper:
              "Paste the WebChat snippet. It will load for logged-in users and use their name and email.",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Type a message or press ''/'' to use the registered quick responses",
        placeholderClosed: "Reopen or accept this chat to send a message.",
        signMessage: "Sign",
      },
      contactDrawer: {
        header: "Contact details",
        buttons: {
          edit: "Edit contact",
        },
        whatsapp: {
          invalid:
            "This number does not have WhatsApp. You can keep it as customer data, but WhatsApp messages cannot be sent to this number.",
          pending:
            "This number has not been verified on WhatsApp yet. You can keep it as customer data; it will be checked again when sending.",
        },
        extraInfo: "Other information",
      },
      ticketOptionsMenu: {
        clearChat: "Clear chat",
        clearChatSuccess: "Chat emptied successfully.",
        clearChatMediaCleanupWarning:
          "The chat was cleared, but {{count}} attachments could not be deleted. Check the server logs.",
        delete: "Delete",
        transfer: "Transfer",
        ai: "AI",
        chatbot: "Chatbot",
        reminders: "Reminders",
        notes: "Notes",
        syncMessages: "Sync messages",
        syncSuccess: "{{count}} message(s) synced.",
        syncSettingsSaved: "Sync settings saved.",
        syncModal: {
          title: "Sync messages",
          autoSyncLabel: "Automatically sync when the chat is created",
          description:
            "When enabled, incoming messages that create a new chat will try to load previous messages automatically. If disabled, you can sync manually from here.",
          syncNow: "Sync now",
          save: "Save",
        },
        confirmationModal: {
          title: "Delete chat #",
          titleFrom: "from contact ",
          message: "Attention! All messages related to this chat will be lost.",
        },
        clearChatConfirmationModal: {
          title: "Clear chat #",
          titleFrom: "from contact ",
          message:
            "Attention! All messages in this chat will be deleted, but the chat will be kept.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      ticketAiModal: {
        title: "Chat AI",
        status: {
          active: "AI is active in this chat.",
          inactive: "AI is off in this chat.",
        },
        buttons: {
          activate: "Activate AI",
          deactivate: "Turn off AI",
          deactivateReset: "Turn off and reset",
          close: "Close",
        },
        toasts: {
          activate: "AI activated in this chat.",
          deactivate: "AI turned off in this chat.",
          deactivateReset: "AI turned off and reset in this chat.",
        },
        confirmationModal: {
          title: "Turn off and reset AI",
          message:
            "Are you sure? This will delete the AI conversation thread for this chat.",
        },
      },
      ticketChatbotModal: {
        title: "Chat chatbot",
        status: {
          active: "Chatbot is active in this chat.",
          inactive: "Chatbot is off in this chat.",
        },
        buttons: {
          activate: "Activate Chatbot",
          activateReset: "Activate and Reset Chatbot",
          deactivate: "Turn off Chatbot",
          deactivateReset: "Turn off and Reset Chatbot",
          close: "Close",
        },
        toasts: {
          activate: "Chatbot activated in this chat.",
          activateReset: "Chatbot activated and reset in this chat.",
          deactivate: "Chatbot turned off in this chat.",
          deactivateReset: "Chatbot turned off and reset in this chat.",
        },
        confirmationModal: {
          activateReset: {
            title: "Activate and reset chatbot",
            message:
              "This will clear the current hierarchy, executions, and pending pauses before activating the chatbot.",
          },
          deactivateReset: {
            title: "Turn off and reset chatbot",
            message:
              "This will clear the current hierarchy, executions, and pending pauses, and the chatbot will remain off.",
          },
        },
      },
      ticketNotesModal: {
        title: "Notes",
        empty: "This chat has no internal notes.",
        buttons: {
          close: "Close",
        },
      },
      ticketRemindersModal: {
        title: "Reminders",
        empty: "This contact has no reminders.",
        form: {
          title: "Title",
          actionType: "Action",
          date: "Date",
          time: "Time",
          recurrenceValue: "Repeat every",
          recurrenceUnit: "Unit",
          sequence: "Sequence",
          message: "Message",
          delay: "Wait for",
          noFile: "No file",
        },
        actionTypes: {
          message: "Message",
          sequence: "Sequence",
        },
        recurrenceUnits: {
          none: "No recurrence",
          seconds: "Seconds",
          minutes: "Minutes",
          hours: "Hours",
          days: "Days",
          weeks: "Weeks",
          months: "Months",
        },
        status: {
          pending: "Pending",
          processing: "Processing",
          completed: "Completed",
          failed: "Failed",
          cancelled: "Cancelled",
        },
        values: {
          untitled: "Untitled reminder",
          completed: "Completed",
        },
        buttons: {
          add: "New reminder",
          save: "Save",
          cancel: "Cancel",
          close: "Close",
          file: "Select file",
          removeFile: "Remove",
          addBlock: "Add message",
        },
        toasts: {
          saved: "Reminder saved successfully.",
          deleted: "Reminder deleted successfully.",
        },
        validation: {
          datetime: "Select date and time.",
          recurrence: "Enter how often it should repeat.",
          sequence: "Select a sequence.",
          message: "Add at least one message or file.",
        },
        confirmationModal: {
          deleteTitle: "Delete reminder",
          deleteMessage: "This action cannot be undone.",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be reverted.",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_SENDING_CHANNEL_MSG:
          "Error sending channel message. Check the connection and reauthorize it if needed.",
        ERR_TICKET_NO_CHANNEL:
          "The ticket does not have an associated connection.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open chat for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_COMPANY_EXPIRED:
          "This account has expired. Please contact the administrator.",
        ERR_NO_COMPANY_FOUND: "No account found with this ID.",
        ERR_INVALID_LIMIT: "The limit must be an integer greater than or equal to zero.",
        ERR_INVALID_AI_CREDIT_LIMIT:
          "The included AI credit limit must be a number greater than or equal to zero.",
        ERR_INVALID_AI_CREDIT_USAGE:
          "The included AI credit usage must be a number greater than or equal to zero.",
        ERR_AI_INCLUDED_CREDITS_EXCEEDED:
          "This account reached its included AI credit limit.",
        ERR_COMPANY_USERS_LIMIT_REACHED:
          "This account has reached its user limit.",
        ERR_COMPANY_WHATSAPPS_LIMIT_REACHED:
          "This account has reached its connection limit.",
        ERR_COMPANY_WHATSAPP_SESSIONS_LIMIT_REACHED:
          "Your plan has reached its active connection limit. To use this connection, disconnect an active connection or purchase an additional connection.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No chat found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating chat on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one area.",
      },
    },
  },
};

export { messages };

